import { togglePlayerLog, foldLog, unfoldLog, playlistLog, staticLogs } from './click-log';
import { sendS2Log } from './s2-log';

export {
  togglePlayerLog,
  foldLog,
  unfoldLog,
  playlistLog,
  staticLogs,
  sendS2Log
};


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/logger/index.js
 **/